import React from "react";
import { OmniDropdownComponent, AlertMessagesService, MediaOpsService } from "../../../../shared";
import { CreateCreativeService } from "../../services/createCreative-service";

export default class OrphanedDeliveredModelComponent extends React.Component {

    defaultState = {
        dropdownValues: {
            campaignValue: [],
            placementValue: [],
        },
        enableMapToObject:true
    };

    constructor(props) {
        super(props);
        this.state = this.defaultState;
    }

    /**
     * Close the model
     */
    closeModel = () => {
        this.props.closeModel();
        this.setState(this.defaultState);
    };

    createChannelMappingPayload = (dropdownValues) => {
        const channel = dropdownValues[0].value;
        const campaign_id = this.props.campaignObj.id;
        const email = this.props.omniProfile.email; 
       const payload = {
            email,
            channel,
            campaign_id,
            mapping: [{taxonomy_details: this.props.mappingObjects.map((item) =>  {return {id: item?.id, parent_id: item?.parent_id, platform_id: item?.platform_id}}),  map: true}]
        };
        return payload;
    };

    /**
     * Map the orphaned delivered data to the placement
     * @param {Object} event
     * @returns {void}
     * @memberof OrphanedDeliveredModelComponent
     */
    mapToObject = () => {
        this.mapOrphaned();
    };

    mapOrphaned = () => {
        this.props.setSpinnerCount(1);
        let payload = {};
        const selectedCount = this.props.mappingObjects?.length;
        const type = this.state.dropdownValues.placementValue?.length ? 'placement' : 'channel';
        const dropdownValues = this.state.dropdownValues.placementValue?.length ? this.state.dropdownValues.placementValue : this.state.dropdownValues.campaignValue;
        
        if (type === 'channel') {
            payload = this.createChannelMappingPayload(dropdownValues);
        } else {
            let selectedPlacementsArray = [];
            this.findAndPushRelatedPlacements(dropdownValues[0], this.props?.placementsData, selectedPlacementsArray);
    
            const taxnomyDetailsArray = [];
            const selectedOrphanedData = this.props.mappingObjects[0];
            this.findAndPushTaxonomyDetails(selectedOrphanedData, this.props.orphanedDataArray, taxnomyDetailsArray);
    
            payload = this.createMappingPayload(selectedPlacementsArray, taxnomyDetailsArray);
        }

        MediaOpsService.mapOrphanedDeliveredData(payload)
            .then((response) => {
                this.props.fetchPlacementTableData();
                this.props.setSpinnerCount(0);

                AlertMessagesService.showSuccessToastMessage(`You have mapped ${selectedCount} orphaned delivered objects to the ${dropdownValues[0].value} ${type}!`);
                this.props.closeModel(dropdownValues);

                this.setState(this.defaultState);
                this.props.setEnableMapToObject(true);
                this.props.fetchOrphanedDeliveredData();
            }).catch((error) => {

                AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.mapToObject, title: `Unable to map ${selectedCount} orphaned delivered objects to the ${dropdownValues[0].value} ${type}!`, bodyMsgArr: [] }]);
                
                this.props.setSpinnerCount(0);
            });
    }   

    /**
     * Creates the payload for mapping orphaned delivered data to the placement.
     *
     * @param {Array<Object>} selectedPlacementsArray - The array of selected placements.
     * @param {Array<Object>} taxnomyDetailsArray - The array of taxonomy details.
     * @returns {Object} - The payload object.
     */
    createMappingPayload = (selectedPlacementsArray, taxnomyDetailsArray) => {
        const payload = {
            mapping: [
                {
                    placement_details: [],
                    taxonomy_details: [],
                    "map": true
                }
            ]
        };

        selectedPlacementsArray.forEach((placement) => {
            payload.mapping[0].placement_details.push({
                id: placement?.placements_id ? placement.placements_id : null,
                parent_id: placement?.parent_id ? placement.parent_id : null,
            });
        });

        taxnomyDetailsArray.forEach((obj) => {
            payload.mapping[0].taxonomy_details.push({
                id: String(obj.id),
                parent_id: obj.parent_id ? obj.parent_id : null,
                platform_id: obj.platform_id
            });
        });

        return payload;
    };

    /**
     * Recursively finds and pushes related placements into the selectedPlacementsArray.
     *
     * @param {Object} selectedPlacement - The selected placement object.
     * @param {Array<Object>} placementsData - The array of placement data objects.
     * @param {Array<Object>} selectedPlacementsArray - The array to push the found placements into.
     * @param {Set<Object>} visited - A set to track visited objects and prevent infinite recursion.
     */
    findAndPushRelatedPlacements = (selectedPlacement, placementsData, selectedPlacementsArray, visited = new Set()) => {
        // Add the current object to the visited set
        visited.add(selectedPlacement);

        placementsData.forEach((placement) => {
            // Finding package to creative items
            if (placement?.parent_id == selectedPlacement?.id && !visited.has(placement)) {
                selectedPlacementsArray.push(placement);
                this.findAndPushRelatedPlacements(placement, placementsData, selectedPlacementsArray, visited);
            }

            // Finding creative to package items
            if (placement?.id == selectedPlacement?.parent_id && !visited.has(placement)) {
                selectedPlacementsArray.push(placement);
                this.findAndPushRelatedPlacements(placement, placementsData, selectedPlacementsArray, visited);
            }
        });
    };

    /**
     * Recursively finds and pushes parent and child taxonomy details into the array.
     *
     * @param {Object} selectedOrphanedData - The selected orphaned data object.
     * @param {Array<Object>} orphanedDataArray - The array of orphaned data objects.
     * @param {Array<Object>} taxnomyDetailsArray - The array to push the found taxonomy details into.
     * @param {Set<Object>} visited - A set to track visited objects and prevent infinite recursion.
     */
    findAndPushTaxonomyDetails = (selectedOrphanedData, orphanedDataArray, taxnomyDetailsArray, visited = new Set()) => {
        // Add the current object to the visited set
        visited.add(selectedOrphanedData);

        orphanedDataArray.forEach((obj, index) => {
            // Child to parent selection
            if (selectedOrphanedData?.parent_id && !visited.has(obj)) {
                if (obj?.id == selectedOrphanedData?.parent_id) {
                    taxnomyDetailsArray.push(obj);
                    this.findAndPushTaxonomyDetails(obj, orphanedDataArray, taxnomyDetailsArray, visited);
                }
            }
            // Parent to child selection
            if (obj?.parent_id == selectedOrphanedData?.id && !visited.has(obj)) {
                taxnomyDetailsArray.push(obj);
                this.findAndPushTaxonomyDetails(obj, orphanedDataArray, taxnomyDetailsArray, visited);
            }

            if (index + 1 === orphanedDataArray.length && taxnomyDetailsArray.length === 0) {
                taxnomyDetailsArray.push(selectedOrphanedData);
            }
        });
    };

    /**
     * Handle the dropdown change
     * @param {Object} event
     */
    handleDropdownChange = (event, type) => {
        const value = event.target.value;
        this.setState({ dropdownValues: {...this.defaultState.dropdownValues, [type]: value }, enableMapToObject: false });
    };

    render() {
        const { isModelOpen, placementDropdownOptions, campaignDropdownOptions } = this.props;
        return (<>
            {isModelOpen && (
                <div className="orphaned-modal-container">
                <div className='orphaned-delivered-modal modal is-active'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <div className='modal-header-title'>
                                Map to placement
                            </div>
                            <hr className='modal-header-divider' />
                            <div className='modal-header-description'>
                                Select a destination placement you would like to map your objects to
                            Select channel and placement from the drop down to map the placement
                            </div>
                        </div>
                        <div className='modal-middle-section'>
                            <div className="dropdown-section">
                                <label htmlFor="orphaned-delivered-dropdown" className='dropdown-section-label'>Map to placement</label>
                                <OmniDropdownComponent
                                typeahead
                                hidefooter
                                searchindropdown
                                options={placementDropdownOptions}
                                placeholder='Select placement'
                                value={this.state.dropdownValues.placementValue}
                                id="orphaned-delivered-dropdown"
                                className="orphaned-delivered-dropdown"
                                onDropdownChange={(event) => this.handleDropdownChange(event, 'placementValue')}
                                />
                            </div>
                               
                            <span className="or-box">Or</span>
                                <div className="dropdown-section">
                                    <label htmlFor="orphaned-delivered-dropdown" className='dropdown-section-label'>Map to campaign “Chilli always on”</label>
                                    <OmniDropdownComponent
                                        typeahead
                                        hidefooter
                                        searchindropdown
                                        options={campaignDropdownOptions}
                                        placeholder='Select the channel where this object belongs'
                                        value={this.state.dropdownValues.campaignValue}
                                        id="orphaned-delivered-dropdown"
                                        className="orphaned-delivered-dropdown"
                                        onDropdownChange={(event) => this.handleDropdownChange(event, 'campaignValue')}
                                    />
                                </div>
                        </div>
                        <div className='modal-footer'>
                            <div className='modal-button-group'>
                                <button className='tertiary' onClick={this.closeModel}>
                                    Cancel
                                </button>
                                <button disabled={this.state.enableMapToObject} onClick={this.mapToObject}>
                                    Map to object
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )}
        </>)
    };
};